import React from "react";
import styles from "./CreateOrderChip.module.scss";

// ITAM-2583 + ITAM-2614: the docked "create" affordance shown while a consult
// prefill is available (phase CHIP). It never opens a form directly — clicking
// it re-opens the TWO-CHOICE prompt (order vs RFZO therapy; the lifecycle owns
// that transition), hence the mode-neutral label. It sits fixed bottom-right,
// below the modal layer and clear of the top VideoConsultAlert.

export interface CreateOrderChipProps {
  callerName: string;
  onOpen: () => void;
}

const CreateOrderChip: React.FC<CreateOrderChipProps> = ({
  callerName,
  onOpen,
}) => (
  <button
    type="button"
    className={styles.chip}
    onClick={onOpen}
    aria-label={`Kreiranje za ${callerName}`}
  >
    <span className={styles.label}>Kreiranje za: {callerName}</span>
  </button>
);

export default CreateOrderChip;
